import locale from 'date-fns/locale/pt-BR';

export { locale };